"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSchema = void 0;
var defaultSchema = {
  controllerAttribute: "data-controller",
  actionAttribute: "data-action",
  targetAttribute: "data-target"
};
exports.defaultSchema = defaultSchema;